<template>
<div class="chartwrapper">
  <div class="row">
    <div class="col">
      <hr class="invisible">
      <h3>SPD und Grüne legen spürbar zu, Linke nur noch knapp über fünf Prozent</h3>
      <hr class="invisible">
      <p>18.02.2019 | <a href="https://www.welt.de/politik/deutschland/article188966981/Forsa-Umfrage-SPD-und-Gruene-legen-spuerbar-zu-Linke-nur-noch-knapp-ueber-fuenf-Prozent.html" target="_blank">welt.de</a></p>

      <div id="stackedbarchartdiv">
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <hr>
      <div class="form-wrapper">
        <form>
          <div class="form-group row">
            <label for="inputCDU" class="col-sm-2 col-form-label">CDU (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputCDU" placeholder="CDU" min="0" max="100" v-model.number="parties.cdu">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputGreen" class="col-sm-2 col-form-label">die Grünen (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputGreen" placeholder="die Grünen" min="0" max="100" v-model.number="parties.green">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputSPD" class="col-sm-2 col-form-label">SPD (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputSPD" placeholder="CDU" min="0" max="100" v-model.number="parties.spd">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputAfD" class="col-sm-2 col-form-label">AfD (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputAfD" placeholder="CDU" min="0" max="100" v-model.number="parties.afd">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputFDP" class="col-sm-2 col-form-label">FDP (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputFDP" placeholder="CDU" min="0" max="100" v-model.number="parties.fdp">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputLeft" class="col-sm-2 col-form-label">die Linke (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputLeft" placeholder="CDU" min="0" max="100" v-model.number="parties.left">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputOther" class="col-sm-2 col-form-label">Andere (%)</label>
            <div class="col-sm-2">
              <input type="number" class="form-control" id="inputOther" placeholder="CDU" min="0" max="100" v-model.number="parties.other">
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  data: function() {
    return {
      stackedBarChart: null,
      parties: {
        cdu: 29,
        green: 21,
        spd: 17,
        afd: 12,
        fdp: 10,
        left: 6,
        other: 5
      }

    }
  },
  methods: {
    drawXCChart: function() {
      let chart = am4core.create(this.$refs.xcchartdiv, am4charts.XYChart);

      chart.paddingRight = 20;

      let data = [];
      let visits = 10;
      for (let i = 1; i < 366; i++) {
        visits += Math.round((Math.random() < 0.5 ? 1 : -1) * Math.random() * 10);
        data.push({
          date: new Date(2018, 0, i),
          name: "name" + i,
          value: visits
        });
      }

      chart.data = data;

      let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
      dateAxis.renderer.grid.template.location = 0;

      let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.tooltip.disabled = true;
      valueAxis.renderer.minWidth = 35;

      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.dateX = "date";
      series.dataFields.valueY = "value";

      series.tooltipText = "{valueY.value}";
      chart.cursor = new am4charts.XYCursor();

      let scrollbarX = new am4charts.XYChartScrollbar();
      scrollbarX.series.push(series);
      chart.scrollbarX = scrollbarX;

      this.chart = chart;
    },
    drawStackedBarChart: function() {
      // Create chart instance
      this.stackedBarChart = am4core.create("stackedbarchartdiv", am4charts.XYChart);

      // Add data
      this.stackedBarChart.data = [{
        "party": "Prozent (%)",
        "cdu": this.parties.cdu,
        "green": this.parties.green,
        "spd": this.parties.spd,
        "afd": this.parties.afd,
        "fdp": this.parties.fdp,
        "left": this.parties.left,
        "other": this.parties.other
      }];

      this.stackedBarChart.legend = new am4charts.Legend();
      this.stackedBarChart.legend.position = "bottom";

      // Create axes
      let categoryAxis = this.stackedBarChart.yAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "party";
      categoryAxis.cursorTooltipEnabled = true;
      categoryAxis.renderer.grid.template.opacity = 0;

      let valueAxis = this.stackedBarChart.xAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      // valueAxis.max = 100;
      valueAxis.renderer.grid.template.disabled = true;
      valueAxis.renderer.grid.template.opacity = 0;
      // valueAxis.renderer.ticks.template.strokeOpacity = 0.5;
      // valueAxis.renderer.ticks.template.stroke = am4core.color("#495C43");
      valueAxis.renderer.ticks.template.length = 10;
      valueAxis.renderer.line.strokeOpacity = 0;
      valueAxis.renderer.baseGrid.disabled = true;
      valueAxis.renderer.labels.template.fill = am4core.color("#FF0000");
      valueAxis.renderer.labels.template.disabled = true;
      // valueAxis.renderer.minGridDistance = 40;

      this.createSeries("cdu", "CDU", "#1D1D1B");
      this.createSeries("green", "die Grünen", "#E63323");
      this.createSeries("spd", "SPD", "#0080C8");
      this.createSeries("afd", "AfD", "#00964F");
      this.createSeries("fdp", "FDP", "#E5017D");
      this.createSeries("left", "die Linke", "#FFEC02");
      this.createSeries("other", "Andere", "#292C34");

      // this.stackedBarChart.cursor = new am4charts.XYCursor();
    },
    // Create series
    createSeries: function(field, name, color) {
      let series = this.stackedBarChart.series.push(new am4charts.ColumnSeries());
      series.dataFields.valueX = field;
      series.dataFields.categoryY = "party";
      series.stacked = true;
      series.name = name;
      series.fill = color;
      series.strokeOpacity = 0;
      series.strokeWidth = 0;

      let labelBullet = series.bullets.push(new am4charts.LabelBullet());
      labelBullet.locationX = 0.5;
      labelBullet.label.text = "{valueX}";
      labelBullet.label.fill = am4core.color("#fff");
    },
    reRenderChart : function() {
      this.stackedBarChart.data = [{
        "party": "Prozent",
        "cdu": this.parties.cdu,
        "green": this.parties.green,
        "spd": this.parties.spd,
        "afd": this.parties.afd,
        "fdp": this.parties.fdp,
        "left": this.parties.left,
        "other": this.parties.other
      }];
      this.stackedBarChart.validateData();
    }
  },
  mounted() {
    // this.drawXCChart();
    this.drawStackedBarChart();

  },
  watch : {
    parties : {
      handler(val) {
        this.reRenderChart();
      },
      deep : true
    }
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

#stackedbarchartdiv {
  margin-top: 50px;
  height: 400px;
}
a {
  color: #e63223;
}

</style>
